<template>
  <basic-modal.container
    id="contractComparisonModal"
    ref="diffContainerModalRef"
    @close="$emit('update:show', false)"
  >
    <basic-modal.step
      id="overview"
      size="maxi"
      :step-title="$t('screen.basket.diff.title')"
      type="acknowledgement"
    >
      <basic-modal.content>
        <diff-container-mobile v-if="isSMViewport" />
        <diff-container-desktop v-else />
      </basic-modal.content>

      <basic-modal.footer
        :primary-label="$t('form.close')"
        @click-primary="diffContainerModalRef.close()"
      />
    </basic-modal.step>
  </basic-modal.container>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue'

  import { events$ } from '@shared/services'

  import useBrowser from '@shared/hooks/useBrowser'

  import DiffContainerDesktop from '@shared/components/Basket/DiffContainer/DiffContainerDesktop'
  import DiffContainerMobile from '@shared/components/Basket/DiffContainer/DiffContainerMobile'
  import { BasicModal } from '@shared/components/Basic'

  import { EVENT_BASKET } from '@shared/config/events'

  // HOOKS
  const { isSMViewport } = useBrowser()

  // INIT
  const emit = defineEmits(['update:show'])
  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
  })

  // DATA
  const diffContainerModalRef = ref()

  // COMPUTED

  // METHODS
  function handleShow(value) {
    if (value) {
      events$.emit(EVENT_BASKET.DIFF_OPENED)
    }

    if (value) {
      diffContainerModalRef.value.open()
    } else if (diffContainerModalRef.value.isOpen) {
      diffContainerModalRef.value.close()
    }
  }

  // WATCHERS
  watch(() => props.show, handleShow)
  watch(
    () => diffContainerModalRef.value?.isOpen,
    value => {
      if (!value) {
        emit('update:show', value)
      }
    }
  )

  // LIFECYCLE HOOKS
  onMounted(() => {
    handleShow(props.show)
  })
</script>
